import * as React from 'react';
import { useSelector } from 'react-redux';

import { OurEstimators } from '../../components/OurEstimators';
import { getUser } from '../../selectors/user';

interface IOurEstimatorsContainerProps {
  className?: string;
}

export const OurEstimatorsContainer: React.VFC<IOurEstimatorsContainerProps> = ({ className }) => {
  const { isAgent } = useSelector(getUser);

  return <OurEstimators className={className} isAgent={Boolean(isAgent)} />;
};
